<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SalesDetailCommissionAllocationGroup from './SalesDetailCommissionAllocationGroup.vue';

const props = defineProps({
  installments: { type: Array, default: () => [] },
  summary: { type: Boolean, default: false },
});
const { t } = useI18n();
const groups = computed(() => [
  {
    key: 'gerentes_gerais',
    label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.GENERAL_MANAGER'),
  },
  { key: 'gerentes', label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.MANAGER') },
  {
    key: 'corretores_vendedores',
    label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.SELLING_BROKER'),
  },
  {
    key: 'corretores_opcionistas',
    label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.OPTIONIST_BROKER'),
  },
]);
const visibleInstallments = group =>
  props.installments.filter(installment => installment[group]?.length);
</script>

<template>
  <template v-for="group in groups" :key="group.key">
    <SalesDetailCommissionAllocationGroup
      v-if="visibleInstallments(group.key).length"
      :group="group"
      :installments="visibleInstallments(group.key)"
      :summary="summary"
    />
  </template>
</template>
